/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Multi-variant products: require an explicit choice before Add to cart.
  // Enabled per template by the "Require variant selection" setting on the
  // product section (see templates/product.multi-variant.json), which prints
  // data-require-variant-selection on <product-info>. Works for any product
  // and any option name — the placeholder reads "Select your <option>".
  function initVariantSelectionGate() {
    var productInfo = document.querySelector('product-info[data-require-variant-selection]');
    if (!productInfo) return;

    var optionName = productInfo.getAttribute('data-selection-option-name') || 'option';
    var toggleText = productInfo.querySelector('[data-popout-toggle-text]');
    if (toggleText) {
      toggleText.textContent = 'Select your ' + optionName;
    }

    var submitBtn = productInfo.querySelector('[data-add-to-cart]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.setAttribute('data-awaiting-variant', 'true');
    }
  }

  document.addEventListener('DOMContentLoaded', initVariantSelectionGate);

  // Re-enable Add to cart as soon as a variant is chosen.
  function enableAddToCartOnVariantChange(variant) {
    var productInfo = document.querySelector('product-info[data-require-variant-selection]');
    if (!productInfo) return;
    var submitBtn = productInfo.querySelector('[data-add-to-cart][data-awaiting-variant]');
    if (submitBtn && variant && variant.available !== false) {
      submitBtn.disabled = false;
      submitBtn.removeAttribute('data-awaiting-variant');
    }
  }

  function setupVariantChangeListener() {
    if (window.subscribe && window.theme?.PUB_SUB_EVENTS?.variantChange) {
      subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function({ data: { variant } }) {
        enableAddToCartOnVariantChange(variant);
      });
      return true;
    }
    return false;
  }

  if (!setupVariantChangeListener()) {
    document.addEventListener('DOMContentLoaded', setupVariantChangeListener);
  }

  // Prevent transparent header on page templates that use section-double.
  // Broadcast opts out when .prevent-transparent-header exists inside the section.
  (function() {
    var first = document.querySelector('.main-content > .shopify-section.section-overlay-header');
    if (first && document.body.classList.contains('template-page')) {
      var guard = document.createElement('div');
      guard.className = 'prevent-transparent-header';
      guard.style.display = 'none';
      first.appendChild(guard);
    }
  })();

  // Section-aware header colour for snap homepage.
  // Section 1 (slideshow): white header + white logo (transparent header allowed).
  // Section 2 (footer): black header + black logo (.on-section-2 class on <html>).
  function initSnapHeaderColour() {
    if (!document.documentElement.classList.contains('snap-homepage')) return;

    const section1 = document.querySelector('[data-site-container]');
    const section2 = document.querySelector('.footer-sections');
    if (!section1 || !section2) return;

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.target === section2) {
          document.documentElement.classList.toggle('on-section-2', entry.isIntersecting);
        }
      });
    }, { threshold: 0.4 });

    observer.observe(section2);
  }

  document.addEventListener('DOMContentLoaded', initSnapHeaderColour);

  // Shop/Cosmos Drawer — left-side nav panel triggered by header links.
  function initShopDrawer() {
    var drawer = document.getElementById('shop-drawer');
    if (!drawer) return;

    // Find Shop and Cosmos nav links by text content
    var shopTrigger = null, cosmosTrigger = null;
    document.querySelectorAll('.navlink--toplevel').forEach(function(link) {
      var text = link.querySelector('.navtext');
      if (!text) return;
      var label = text.textContent.trim();
      if (label === 'Shop') shopTrigger = link;
      if (label === 'Cosmos') cosmosTrigger = link;
    });

    function setupTrigger(triggerEl, panel, attrName) {
      if (!triggerEl) return;
      var disclosure = triggerEl.closest('hover-disclosure');
      if (disclosure) {
        disclosure.setAttribute(attrName, '');
        disclosure.addEventListener('mouseenter', function(e) {
          e.stopImmediatePropagation();
        }, true);
      } else {
        triggerEl.setAttribute(attrName, '');
      }

      triggerEl.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var isOpen = drawer.getAttribute('aria-hidden') === 'false';
        var currentPanel = drawer.getAttribute('data-active-panel');
        if (isOpen && currentPanel === panel) {
          closeDrawer();
        } else {
          openDrawer(panel);
        }
      });
    }

    setupTrigger(shopTrigger,   'shop',   'data-shop-trigger');
    setupTrigger(cosmosTrigger, 'cosmos', 'data-cosmos-trigger');

    // Mobile: hamburger opens the drawer's mobile panel (the theme has no
    // mobile-menu section; capture-phase so the theme's own handler never runs).
    var hamburger = document.querySelector('[data-drawer-toggle="hamburger"]');
    if (hamburger) {
      hamburger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var isOpen = drawer.getAttribute('aria-hidden') === 'false';
        if (isOpen) { closeDrawer(); } else { openDrawer('mobile'); }
      }, true);
    }

    // Mobile tabs: Shop / Cosmos switch inside the drawer (Jessica McCormack-style)
    drawer.querySelectorAll('[data-mtab-btn]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var target = btn.getAttribute('data-mtab-btn');
        drawer.querySelectorAll('[data-mtab-btn]').forEach(function(b) {
          b.classList.toggle('is-active', b === btn);
        });
        drawer.querySelectorAll('[data-mtab]').forEach(function(list) {
          list.hidden = list.getAttribute('data-mtab') !== target;
        });
      });
    });

    // Mobile submenu panels: slide in on expander tap, slide out on back
    drawer.querySelectorAll('[data-mpanel-target]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var panel = drawer.querySelector('[data-mpanel="' + btn.getAttribute('data-mpanel-target') + '"]');
        if (panel) panel.classList.add('is-open');
      });
    });
    drawer.querySelectorAll('[data-mpanel-back]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        btn.closest('.shop-drawer__mpanel').classList.remove('is-open');
      });
    });

    // Close on overlay click or Escape
    drawer.querySelectorAll('[data-shop-drawer-close]').forEach(function(el) {
      el.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeDrawer();
    });

    // Expanders: scoped to their own panel so Shop and Cosmos don't interfere
    drawer.querySelectorAll('.shop-drawer__expander').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var alreadyOpen = btn.getAttribute('aria-expanded') === 'true';
        var panelEl = btn.closest('.shop-drawer__cols');
        var subPanel = panelEl ? panelEl.querySelector('.shop-drawer__sub-panel') : null;

        panelEl.querySelectorAll('.shop-drawer__expander').forEach(function(other) {
          other.setAttribute('aria-expanded', 'false');
        });
        panelEl.querySelectorAll('.shop-drawer__sub-items').forEach(function(list) {
          list.hidden = true;
        });

        if (alreadyOpen) {
          if (subPanel) subPanel.classList.remove('is-open');
        } else {
          var targetId = btn.getAttribute('data-sub-target');
          var subList = panelEl.querySelector('[data-sub-id="' + targetId + '"]');
          if (subList) {
            subList.hidden = false;
            btn.setAttribute('aria-expanded', 'true');
            if (subPanel) subPanel.classList.add('is-open');
          }
        }
      });
    });
  }

  function openDrawer(panel) {
    var drawer = document.getElementById('shop-drawer');
    if (!drawer) return;
    drawer.setAttribute('data-active-panel', panel);
    drawer.setAttribute('aria-hidden', 'false');
    document.body.setAttribute('data-drawer-panel', panel);
    document.body.classList.add('shop-drawer-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    var drawer = document.getElementById('shop-drawer');
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('shop-drawer-open');
    document.body.removeAttribute('data-drawer-panel');
    document.body.style.overflow = '';
    drawer.querySelectorAll('.shop-drawer__expander').forEach(function(btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
    drawer.querySelectorAll('.shop-drawer__sub-items').forEach(function(list) {
      list.hidden = true;
    });
    drawer.querySelectorAll('.shop-drawer__sub-panel').forEach(function(sp) {
      sp.classList.remove('is-open');
    });
    drawer.querySelectorAll('.shop-drawer__mpanel').forEach(function(mp) {
      mp.classList.remove('is-open');
    });
    // Reset mobile tabs to Shop for next open
    drawer.querySelectorAll('[data-mtab-btn]').forEach(function(b) {
      b.classList.toggle('is-active', b.getAttribute('data-mtab-btn') === 'shop');
    });
    drawer.querySelectorAll('[data-mtab]').forEach(function(list) {
      list.hidden = list.getAttribute('data-mtab') !== 'shop';
    });
  }

  // Keep legacy name so any other code referencing closeShopDrawer still works
  var closeShopDrawer = closeDrawer;

  document.addEventListener('DOMContentLoaded', initShopDrawer);

  // Atelier pause bar — floats over the page (never shifts layout) and stays
  // dismissed for the session once closed.
  function initAtelierBar() {
    var bar = document.querySelector('[data-atelier-bar]');
    if (!bar) return;
    if (sessionStorage.getItem('hriamAtelierBarClosed') === '1') {
      bar.remove();
      return;
    }
    bar.hidden = false;
    var close = bar.querySelector('[data-atelier-bar-close]');
    if (close) {
      close.addEventListener('click', function () {
        sessionStorage.setItem('hriamAtelierBarClosed', '1');
        bar.classList.add('is-closing');
        setTimeout(function () { bar.remove(); }, 260);
      });
    }
  }

  document.addEventListener('DOMContentLoaded', initAtelierBar);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
